import { p } from './core.js'

// Categoria 4 — Balcões + Buffets + Racks (R3)
// SKUs: BAL-A..D (4), BUF-2P-A..D (4), BUF-3P-A..D (4), BUF-4P-A..D (4), RACK-A..H (8) = 24
//
// Moldura 6mm largura 0.05m (mesmo padrão da família CM).
// h_gav_mesa = 0.10, h_gav_buffet = 0.15.
// Bases de madeira terceirizadas (R$ 99,90 / un) NÃO entram no MDF; são adicional
// aplicado por fora (em adicionais.js / precosAdicionais).

const L_MOLDURA = 0.05

export const BALCOES_BUFFETS_RACKS = {

  // ── BAL-A — Balcão Alto Básico (tampo superior + tampo intermediário) ───────
  'Balcão Alto Básico': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral (altura cheia)',          '15', v => v.P * v.A, 2),
      p('Tampo superior (coroamento)',     '15', v => v.C * v.P, 1),
      p('Tampo intermediário (balcão)',    '15', v => v.C * v.P, 1),
      p('Testeira frontal alta',           '15', v => v.C * (v.A * 0.3), 1),
      p('Fundo do móvel',                  '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BAL-B — Balcão Alto com Nicho Duplo + 1 Gaveta ──────────────────────────
  // A_balcao = 0.90 (altura padrão do tampo intermediário).
  'Balcão Alto com Nicho e Gaveta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral externa',          '15', v => v.P * v.A, 2),
      p('Tampo superior',           '15', v => v.C * v.P, 1),
      p('Tampo intermediário',      '15', v => v.C * v.P, 1),
      p('Divisória vertical nicho', '15', v => v.P * 0.90, 1),
      p('Prateleira nicho',         '15', v => 0.40 * v.P, 1),
      p('Base nicho',               '15', v => 0.40 * v.P, 1),
      p('Frente gaveta',            '15', v => 0.40 * 0.10, 1),
      p('Traseira gaveta',          '15', v => 0.40 * 0.10, 1, 'branco'),
      p('Lateral gaveta',           '15', v => v.P * 0.10, 2, 'branco'),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',          '6',  v => 0.40 * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 1, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BAL-C — Balcão Médio com 1 Gaveta + Nicho Duplo ─────────────────────────
  'Balcão Médio com Gaveta e Nicho': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',              '15', v => v.C * v.P, 1),
      p('Prateleira nicho',  '15', v => v.C * v.P, 1),
      p('Frente gaveta',     '15', v => v.C * 0.10, 1),
      p('Traseira gaveta',   '15', v => v.C * 0.10, 1, 'branco'),
      p('Lateral gaveta',    '15', v => v.P * 0.10, 2, 'branco'),
      p('Fundo do móvel',    '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',   '6',  v => v.C * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 1, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BAL-D — Balcão Médio com Gaveta Larga + Nicho + Porta ───────────────────
  'Balcão Médio Misto': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1),
      p('Divisória horizontal', '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória vertical',   '15', v => v.P * (v.A - 0.10), 1, 'branco'),
      p('Prateleira nicho',     '15', v => (v.C/2) * v.P, 1),
      p('Porta de giro',        '15', v => (v.C/2) * (v.A - 0.10), 1),
      p('Frente gaveta sup.',   '15', v => v.C * 0.10, 1),
      p('Traseira gaveta sup.', '15', v => v.C * 0.10, 1, 'branco'),
      p('Lateral gaveta sup.',  '15', v => v.P * 0.10, 2, 'branco'),
      p('Fundo do móvel',       '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',      '6',  v => v.C * v.P, 1),
    ],
    ferragens: { dobradica: 2, corredica: 1, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BUF-2P-A — Buffet 2 Portas com Prateleira Interna ───────────────────────
  'Buffet 2 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',     '15', v => v.P * v.A, 2),
      p('Tampo',       '15', v => v.C * v.P, 1),
      p('Base',        '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira',  '15', v => v.C * v.P, 1, 'branco'),
      p('Porta de giro','15', v => (v.C/2) * v.A, 2),
      p('Fundo do móvel','6', v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BUF-2P-C — 1 Porta + Nicho Duplo (catálogo: 2 colunas, 1 porta + nicho) ─
  'Buffet 1 Porta com Nicho': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Divisória vertical',   '15', v => v.P * v.A, 1),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira interna (fechada)','15', v => (v.C/2) * v.P, 1, 'branco'),
      p('Prateleira nicho',     '15', v => (v.C/2) * v.P, 1),
      p('Porta de giro',        '15', v => (v.C/2) * v.A, 1),
      p('Fundo do móvel',       '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 2, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BUF-2P-D — Buffet 2 Portas com Espaço Eletro ────────────────────────────
  // C_armario default = C/2 (metade da bancada é armário, metade é vão do eletro).
  // Cliente pode customizar via dimensionamento real; usamos default.
  'Buffet 2 Portas com Espaço Eletro': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Divisória vertical',   '15', v => v.P * v.A, 1),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base (só armário)',    '15', v => (v.C/2) * v.P, 1, 'branco'),
      p('Prateleira interna',   '15', v => (v.C/2) * v.P, 1, 'branco'),
      p('Porta de giro',        '15', v => (v.C/4) * v.A, 2),
      p('Fundo do móvel',       '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BUF-3P-A — Buffet 3 Portas (prat C×P contínua, qtd 1) ───────────────────
  'Buffet 3 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Divisória vertical',            '15', v => v.P * v.A, 2, 'branco'),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira interna contínua',   '15', v => v.C * v.P, 1, 'branco'),
      p('Porta de giro',                 '15', v => (v.C/3) * v.A, 3),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 6, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BUF-3P-D — Buffet 3 Portas com 3 Gavetas Laterais ───────────────────────
  // 2 colunas porta + 1 coluna lateral com 3 gavetas. h_gav_buffet = 0.15.
  'Buffet 3 Portas com Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Divisória vertical',            '15', v => v.P * v.A, 2, 'branco'),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira interna (portas)',   '15', v => (v.C/3) * v.P, 2, 'branco'),
      p('Porta de giro',                 '15', v => (v.C/3) * v.A, 2),
      p('Frente gaveta',                 '15', v => (v.C/3) * 0.15, 3),
      p('Traseira gaveta',               '15', v => (v.C/3) * 0.15, 3, 'branco'),
      p('Lateral gaveta',                '15', v => v.P * 0.15, 6, 'branco'),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',               '6',  v => (v.C/3) * v.P, 3),
    ],
    ferragens: { dobradica: 4, corredica: 3, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BUF-4P-A — Buffet 4 Portas (prat C×P contínua, 1 div vertical) ──────────
  'Buffet 4 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Divisória vertical',            '15', v => v.P * v.A, 1, 'branco'),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira interna contínua',   '15', v => v.C * v.P, 1, 'branco'),
      p('Porta de giro',                 '15', v => (v.C/4) * v.A, 4),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── BUF-4P-D — Buffet 4 Portas com Adega/Garrafeira ─────────────────────────
  // 2 portas laterais + 2 colunas adega centrais (25cm fixo cada, 4 div horiz cada).
  'Buffet 4 Portas Adega': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Divisória vertical',            '15', v => v.P * v.A, 3, 'branco'),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira interna (portas)',   '15', v => ((v.C - 0.50)/2) * v.P, 2, 'branco'),
      p('Porta de giro',                 '15', v => ((v.C - 0.50)/2) * v.A, 2),
      p('Divisória adega horizontal',    '15', v => 0.25 * v.P, 8),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── RACK-A — Rack 2 Basculantes e 2 Nichos ──────────────────────────────────
  'Rack 2 Basculantes e 2 Nichos': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Divisória vertical',   '15', v => v.P * v.A, 1),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória horizontal', '15', v => v.C * v.P, 1),
      p('Porta basculante',     '15', v => (v.C/2) * (v.A/2), 2),
      p('Fundo do móvel',       '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 2, rodinha: 0, cabide: 0 },
  },

  // ── RACK-B — Rack Thalita (lateral+tampo+div horiz em 25mm, 4 portas) ───────
  'Rack Thalita': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '25', v => v.P * v.A, 2),
      p('Divisória vertical',            '15', v => v.P * v.A, 3, 'branco'),
      p('Tampo',                         '25', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória horizontal contínua', '25', v => v.C * v.P, 1),
      p('Porta de giro',                 '15', v => (v.C/4) * (v.A/2), 4),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── RACK-C — Rack 4 Portas (4 colunas, prat contínua) ───────────────────────
  'Rack 4 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Divisória vertical',            '15', v => v.P * v.A, 3, 'branco'),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira interna contínua',   '15', v => v.C * v.P, 1, 'branco'),
      p('Porta de giro',                 '15', v => (v.C/4) * v.A, 4),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 8, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── RACK-E — Rack 2 Portas e Nicho Duplo Central ────────────────────────────
  'Rack 2 Portas e Nicho Duplo Central': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                       '15', v => v.P * v.A, 2),
      p('Divisória vertical',            '15', v => v.P * v.A, 2),
      p('Tampo',                         '15', v => v.C * v.P, 1),
      p('Base',                          '15', v => v.C * v.P, 1),
      p('Divisória horizontal (nicho)',  '15', v => (v.C/3) * v.P, 1),
      p('Porta de giro',                 '15', v => (v.C/3) * v.A, 2),
      p('Fundo do móvel',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

}
